// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AccountInfoCard_ai__27Lvn {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 3rem 5rem 3rem 5rem;
  border-radius: 1rem;
  background-color: var(--color-white);
  height: auto;
  gap: 2rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
}
@media only screen and (max-width: 56.25em) {
  .AccountInfoCard_ai__27Lvn {
    height: auto;
    padding: 3rem;
  }
}
.AccountInfoCard_ai__line__AwVhT {
  border-top: 1px solid var(--color-grey-2);
}
.AccountInfoCard_ai__copy__9puFA {
  display: flex;
  font-size: 3rem;
  color: var(--color-white);
  cursor: pointer;
  background-color: var(--color-dark);
  padding: 1rem 2rem;
  border-radius: 0.5rem;
  align-items: center;
}
.AccountInfoCard_ai__copy__9puFA > :not(:last-child) {
  margin-right: 2rem;
}
.AccountInfoCard_ai__bank__zb44D {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 2rem;
  border-radius: 1rem;
  background-color: var(--color-fash-primary-4);
  gap: 1rem;
}
@media only screen and (max-width: 56.25em) {
  .AccountInfoCard_ai__bank__zb44D {
    height: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Wallet/AccountInfoCard.module.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,4BAAA;EACA,mBAAA;EACA,oCAAA;EACA,YAAA;EACA,SAAA;EACA,4CAAA;AADF;AAGE;EAXF;IAYI,YAAA;IACA,aAAA;EAAF;AACF;AAEE;EACE,yCAAA;AAAJ;AAGE;EACE,aAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;EACA,mCAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;AADJ;AAGI;EACE,kBAAA;AADN;AAKE;EACE,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,6CAAA;EACA,SAAA;AAHJ;AAKI;EATF;IAUI,YAAA;EAFJ;AACF","sourcesContent":["@import \"../variables/breakpoints\";\n\n.ai {\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  padding: 3rem 5rem 3rem 5rem;\n  border-radius: 1rem;\n  background-color: var(--color-white);\n  height: auto;\n  gap: 2rem;\n  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\n  @media only screen and (max-width: $bp-900) {\n    height: auto;\n    padding: 3rem;\n  }\n\n  &__line {\n    border-top: 1px solid var(--color-grey-2);\n  }\n\n  &__copy {\n    display: flex;\n    font-size: 3rem;\n    color: var(--color-white);\n    cursor: pointer;\n    background-color: var(--color-dark);\n    padding: 1rem 2rem;\n    border-radius: 0.5rem;\n    align-items: center;\n\n    & > :not(:last-child) {\n      margin-right: 2rem;\n    }\n  }\n\n  &__bank {\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n    padding: 2rem;\n    border-radius: 1rem;\n    background-color: var(--color-fash-primary-4);\n    gap: 1rem;\n\n    @media only screen and (max-width: $bp-900) {\n      height: auto;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ai": `AccountInfoCard_ai__27Lvn`,
	"ai__line": `AccountInfoCard_ai__line__AwVhT`,
	"ai__copy": `AccountInfoCard_ai__copy__9puFA`,
	"ai__bank": `AccountInfoCard_ai__bank__zb44D`
};
export default ___CSS_LOADER_EXPORT___;
